import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import {
  CX,
} from '../constants'
import Button from './button'
import Icon from './icon'
import Image from './image'
import ResponsiveClassesComponent from '../features/ui/util/responsive_classes_component'
import VerifiedAccountIcon from './verified_account_icon'
import VerifiedGroupIcon from './verified_group_icon'

class SidebarSectionItem extends React.PureComponent {

  state = {
    hovering: false,
  }

  handleOnMouseEnter = () => {
    this.setState({ hovering: true })
  }

  handleOnMouseLeave = () => {
    this.setState({ hovering: false })
  }

  render() {
    const {
      to,
      active,
      icon,
      image,
      title,
      me,
      count,
      onClick,
      href,
      buttonRef,
      location,
      shortcutComponent,
      showVerified,
      showVerifiedGroup,
      isGroup,
      slimLayout,
    } = this.props
    const { hovering } = this.state

    const iconSize = '20px'
    const currentPathname = location.pathname
    const shouldShowActive = hovering || active || currentPathname === to || currentPathname === href
    const isHighlighted = ['/notifications', '/messages'].indexOf(to) > -1 || title === 'Notifications'

    const containerClasses = CX({
      d: 1,
      maxW100PC: 1,
      w100PC: 1,
      flexRow: 1,
      py5: !slimLayout,
      px5: !slimLayout,
      py2: slimLayout,
      px2: slimLayout,
      aiCenter: 1,
      radiusSmall: 1,
      outlineNone: 1,
      bgSubtle_onHover: 1,
      bgTransparent: !shouldShowActive,
      bgPrimary: shouldShowActive,
    })

    const countClasses = CX({
      d: 1,
      text: 1,
      textAlignCenter: 1,
      minW20PX: 1,
      mlAuto: 1,
      fs12PX: 1,
      px5: 1,
      mr2: 1,
      lineHeight15: 1,
      ml5: 1,
      cSecondary: !isHighlighted,
      cWhite: isHighlighted,
      bgRed: isHighlighted,
      circle: isHighlighted,
    })

    const contentClasses = CX({
      d: 1,
      flexNormal: 1,
      textOverflowEllipsis: 1,
      overflowWrapBreakWord: 1,
      flexRow: 1,
      w100PC: 1,
      pr10: 1,
      pl10: !!icon || !!image || !!shortcutComponent,
    })

    const imageClass = isGroup ? _s.radiusTiny : _s.circle
    const mainFontSize = slimLayout ? _s.fs16PX : _s.fs18PX

    return (
      <Button
        to={to}
        href={href}
        onClick={onClick}
        noClasses
        buttonRef={buttonRef}
        onMouseEnter={() => this.handleOnMouseEnter()}
        onMouseLeave={() => this.handleOnMouseLeave()}
        className={[_s.d, _s.noUnderline, _s.outlineNone, _s.cursorPointer, _s.w100PC, _s.bgTransparent].join(' ')}
      >
        <div className={containerClasses}>
          {
            !!icon && 
            <div className={[_s.d, _s.circle, _s.bgSecondary, _s.aiCenter, _s.jcCenter, _s.h30PX, _s.w30PX].join(' ')}>
              <Icon id={icon} className={[_s.cPrimary, _s.fillPrimary].join(' ')} size='16px' />
            </div>
          }
          
          {
            !!image &&
            <Image
              alt={title}
              className={[imageClass, _s.overflowHidden].join(' ')}
              width='30px'
              height='30px'
              cfWidthPX='30px'
              src={image}
            />
          }
          
          {
            !!shortcutComponent && shortcutComponent
          }

          <div className={contentClasses}>
            <ResponsiveClassesComponent
              classNames={[_s.d, _s.fw400, mainFontSize, _s.aiCenter, _s.text, _s.textOverflowEllipsis, _s.cPrimary].join(' ')}
              classNamesSmall={[_s.d, _s.fw400, _s.fs14PX, _s.text, _s.textOverflowEllipsis, _s.cPrimary].join(' ')}
            >
              {title}
              {showVerified &&  <VerifiedAccountIcon className={[_s.mbNeg2PX, _s.ml5].join(' ')} size='16px' />}
              {showVerifiedGroup &&  <VerifiedGroupIcon className={[_s.mbNeg2PX, _s.ml5].join(' ')} size='16px' />}
            </ResponsiveClassesComponent>
          </div>

          {
            (count > 0 || count === '99+') &&
            <span className={countClasses}>
              {count}
            </span>
          }
        </div>
      </Button>
    )
  }

}

SidebarSectionItem.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  showVerified: PropTypes.bool,
  showVerifiedGroup: PropTypes.bool,
  icon: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  me: PropTypes.bool,
  slimLayout: PropTypes.bool,
  suffix: PropTypes.node,
  buttonRef: PropTypes.func,
}

export default withRouter(SidebarSectionItem)
